import React, { useCallback } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import Image from "next/image";

interface BlueDropDownProps {
  value: string;
  title: string;
  content: Array<{ id: number; title: string; image?: string; url?: string }>;
  fieldName: string;
  onChange?: (selectedCountry: string, title: string) => void;
  disable?: boolean;
}

export function CustomBlueSelect({
  title,
  content,
  onChange,
  fieldName,
  value,
  disable,
}: BlueDropDownProps) {
  const handleValueChange = useCallback(
    (newValue: string) => {
      onChange?.(newValue, fieldName);
    },
    [onChange, fieldName]
  );
  return (
    <Select
      disabled={disable}
      value={value}
      defaultValue={value}
      onValueChange={handleValueChange}
    >
      <SelectTrigger className="max-w-auto border-2 border-[#3777ff] w-full bg-white text-[#3777ff] text-sm sm:text-base md:text-lg xl:text-xl font-semibold ff_poppins py-[10px] focus:outline-hidden">
        <SelectValue placeholder={title} />
      </SelectTrigger>
      <SelectContent className="z-[9999]">
        <SelectGroup className="bg-white rounded-[8px]">
          {content.length === 0 && (
            <SelectLabel className="text-[#3777ff] flex cursor-pointer w-full font-semibold text-xl ff_poppins leading-[30px] py-[10px] px-5 hover:bg-[#2367f9] duration-300 ease-out hover:outline-hidden focus:outline-hidden">
              Loading....
            </SelectLabel>
          )}
          {content.map((item) => (
            <SelectItem
              key={item.id}
              value={item.title} // Ensure unique value
              className="text-[#3777ff] flex cursor-pointer w-full font-semibold text-xl ff_poppins leading-[30px] py-[10px] px-5 hover:bg-[#2367f9] duration-300 ease-out hover:text-white hover:outline-hidden focus:outline-hidden"
            >
              <div className="flex items-center justify-between w-full min-w-[270px] sm:min-w-[320px] md:min-w-[320px]">
                <span className="text-sm sm:text-base md:text-lg xl:text-xl font-semibold ff_poppins">
                  {item.title}
                </span>
                {item.image && (
                  <Image
                    className="max-w-[35px] sm:max-w-[48px]"
                    src={item.image}
                    alt="flags"
                    width={48}
                    height={33}
                  />
                )}
              </div>
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
